//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const WriteUserDisplayName: FeatureFlag = {"Id":"WriteUserDisplayName","Label":"(KILL)[10.10]WriteUserDisplayName","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
